<style>
    .grid-off .top    { /* background-color: green; */ grid-area: top;    }
    .grid-off .bottom { /* background-color: red  ; */ grid-area: bottom; }
    .grid-off .logo   { /* background-color: black; */ grid-area: logo;   }
    .grid-off .form   { /* background-color: blue ; */ grid-area: form;   }

    .grid-off {
        display: grid;
        min-height: 100vh;
        background: rgb(134,18,114);
        background: linear-gradient(90deg, rgba(134,18,114,1) 0%, rgba(212,11,177,1) 50%, rgba(134,18,114,1) 100%);

        grid-template-areas: "top top"
                             "logo form"
                             "bottom bottom"
                             ;
    
        grid-template-columns: 1fr 1fr;
        grid-template-rows   : 1fr 4fr 1fr;
    }

    .grid-off .logo {
        justify-self: center;
        align-self  : center;
    }


    @media screen and (max-width: 990px) {
        .grid-off {
            border: 1px solid white;

            grid-template-columns: 1fr 1fr;

            grid-template-rows: 1fr 4fr 1fr;

            grid-template-areas: "top top"
                                 "form form"
                                 "bottom bottom"
                                 ;
        }

        .grid-off .logo {
            display: none;
        }

        .grid-off .form {
            justify-self: center;
        }
    }

    .f {
        background-color: white; 
        width: 300px;
    }
</style>

<script>
    import { Router, Route } from "svelte-routing"
    import Login    from './Login.svelte'
    import Activate from './Activate.svelte'
    import Invite   from './Invite.svelte'

    export let onLogin
    export let onActivated
</script>

<div class="grid-off">
    <div class="top"></div>
    <div class="logo"><img src="logo-white.svg" alt="Dogma"/></div>
    <div class="form">
        <Router>
            <Route path="/promo">
                <Invite />
            </Route>
            <Route path='/ativar'>
                <Activate {onActivated} />
            </Route>
            <Route>
                <Login {onLogin} />
                <div class="f"><!-- I have no clue why, but this div centers the form --></div>        
            </Route>
        </Router>
    </div>
    <div class="bottom"></div>
</div>
